import styled from "styled-components";
import { Upload, Button } from "antd";

export const UploadList = styled(Upload)`
`;

export const Dragger = styled(Upload.Dragger)`
  height: ${({ fullScreen }) => fullScreen ? " calc(100vh - 220px)" : "200px"} !important;
  transition: height 0.3s ease-in-out !important;
`;

export const ImportButton = styled(Button)`
`;